import { createReducer } from '@reduxjs/toolkit';
import { clearAllProjectData } from '../actions/clearAllProjectData';
import resetCalculationDataForDocument from '../actions/resetCalculationDataForDocument';
import { trimIfString } from '../utilities/keyUtilities';
import headerRowIngested from '../actions/headerRowIngested';

const timePeriodsReducer = createReducer(
  {},
  {
    [headerRowIngested]: (state, action) => {
      if (
        !action.payload ||
        !action.payload.code ||
        !action.payload.headers ||
        !action.payload.config
      ) {
        return state;
      }
      const { code, headers, config } = action.payload;
      const dataHeaders = headers
        .slice(config.summableColumnStartIndex)
        .filter((h) => h !== '')
        .map(trimIfString);

      return {
        ...state,
        [code]: dataHeaders,
      };
    },
    [resetCalculationDataForDocument]: (state, action) => {
      if (!action.payload || !action.payload.documentCode) {
        return state;
      }
      const { documentCode } = action.payload;
      delete state[documentCode];
      return state;
    },
    [clearAllProjectData]: () => ({}),
  }
);

export default timePeriodsReducer;
